export const TopPageReportQuantity = 5;
export const LambdaApiGateWay = window.location.hostname === "localhost" ? process.env.REACT_APP_LAMBDA_ENDPOINT_DEV : process.env.REACT_APP_LAMBDA_ENDPOINT_PRD ;